import React from 'react'
import CommonNavbar from '../../components/CommonNavbar/CommonNavbar'
import CommonFooter from '../../components/CommonFooter/CommonFooter'

import { CheckCircle } from 'lucide-react'

const SoilTestingLab = () => {
  return (
    <>
      <CommonNavbar />
      <div className='py-5'>
        <div className='container px-md-5'>
          <div className='p-6 max-w-5xl mx-auto space-y-8'>
            {/* Header */}
            <div className='text-center space-y-3'>
              <h1 className='text-3xl font-bold clr_dark_green'>
                Farmer’s City Soil Testing Laboratory
              </h1>
              <p className='text-gray-600 max-w-2xl mx-auto'>
                Helping farmers understand soil composition, identify nutrient
                deficiencies, and make informed decisions for better
                agricultural outcomes.
              </p>
            </div>

            {/* Key Aspects */}
            <section>
              <h2 className='text-2xl font-semibold clr_dark_green mb-4'>
                Key Aspects
              </h2>
              <div className='grid md:grid-cols-2 gap-6'>
                {[
                  {
                    title: 'Integrated Service',
                    desc: 'Part of a holistic suite including crop advisory, quality assessment, and subscriptions.'
                  },
                  {
                    title: 'Accurate Results',
                    desc: 'Advanced tools ensure reliable and precise test results.'
                  },
                  {
                    title: 'Quick Turnaround Time',
                    desc: 'State-of-the-art equipment for faster decision-making.'
                  },
                  {
                    title: 'Cost-Effective Solutions',
                    desc: 'Affordable testing without compromising accuracy.'
                  },
                  {
                    title: 'Data Analytics',
                    desc: 'Combines soil test data with weather and yield history for insights.'
                  },
                  {
                    title: 'Training and Support',
                    desc: 'Franchisee employees trained to interpret results and guide farmers.'
                  }
                ].map((item, idx) => (
                  <div
                    key={idx}
                    className='rounded-2xl shadow-md border border-green-100 p-4 space-y-2 bg-white'
                  >
                    <h3 className='font-semibold clr_dark_green'>
                      {item.title}
                    </h3>
                    <p className='text-gray-600'>{item.desc}</p>
                  </div>
                ))}
              </div>
            </section>

            {/* Benefits */}
            <section>
              <h2 className='text-2xl font-semibold clr_dark_green mb-4'>
                Benefits
              </h2>
              <ul className='space-y-3 text-gray-700'>
                <li className='flex items-start space-x-2'>
                  <CheckCircle className='w-5 h-5 clr_dark_green mt-1' />
                  <span>
                    Improve crop yields and quality with balanced fertilizer
                    use.
                  </span>
                </li>
                <li className='flex items-start space-x-2'>
                  <CheckCircle className='w-5 h-5 clr_dark_green mt-1' />
                  <span>
                    Reduce environmental pollution from excessive chemicals.
                  </span>
                </li>
                <li className='flex items-start space-x-2'>
                  <CheckCircle className='w-5 h-5 clr_dark_green mt-1' />
                  <span>
                    Enhance resource efficiency by investing in the right crops.
                  </span>
                </li>
                <li className='flex items-start space-x-2'>
                  <CheckCircle className='w-5 h-5 clr_dark_green mt-1' />
                  <span>
                    Encourage collaboration between farmers and agronomists for
                    sustainable farming systems.
                  </span>
                </li>
              </ul>
            </section>

            {/* Closing Note */}
            <section className='bg-green-50 rounded-2xl p-6 text-center shadow-md'>
              <p className='text-gray-700 max-w-3xl mx-auto'>
                The establishment of Farmer’s City Soil Testing Laboratories
                will strengthen the agricultural ecosystem by equipping farmers
                with the knowledge to make informed decisions, driving positive
                change across India and beyond.
              </p>
            </section>
          </div>
        </div>
      </div>
      <CommonFooter />
    </>
  )
}

export default SoilTestingLab
